// Whole Component Tejashwini
import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Select, MenuItem, FormControl, InputLabel, FormHelperText } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TextField from "@mui/material/TextField";
import Layout from "./layout";
import axios from "axios";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import UserForm from "./userForm";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import SearchBox from "./searchbox";
import TableSortLabel from "@mui/material/TableSortLabel";
import { alpha } from "@mui/material/styles";
import DialogTitle from '@mui/material/DialogTitle';
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import BrandIcon from '../images/brand-01.png'; 
import { useNavigate } from "react-router-dom";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Container = styled("div")({
  padding: "5rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
});

const ModalStyle = {
  position: "absolute",
  borderRadius: "5px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
};

export default function Brand() {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [isUserFormOpen, setIsUserFormOpen] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [deleteMsg, setDeleteMsg] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("user_id");
  const [isAddCategoryModal, setisAddCategoryModal] = useState(false);
  const [isEditCategoryModal, setisEditCategoryModal] = useState(false);

  const [categoryId, setCategoryId] = useState(0);
  const [brandId, setBrandId] = useState("");
  const [brandName, setBrandName] = useState("");
  const [categoryLabel, setCategoryLabel] = useState("Select Category");
  const [categoryLabel2, setCategoryLabel2] = useState("");
  const [categoryNameError, setCategoryNameError] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [newFieldValue, setNewFieldValue] = useState('');
  const [newFieldError, setNewFieldError] = useState(false);
  const [newFieldLabel, setNewFieldLabel] = useState("Enter Brand");
  const [category, setcategory] = useState([{}]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null); // Add this to your state
  const [categoryName, setCategoryName] = useState([{}]);
  const [categoryError, setCategoryError] = useState();
  const [selectedCategory, setSelectedCategory] = useState("");
  const [attributeName, setattributeName] = useState("");
  const [attributevalue, setattributeValue] = useState("");
  const [brandLabel, setBrandLabel] = useState("Enter Brand");
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedRow, setSelectedRow] = useState("");
  const [selectedbrandid, setSelectedbrandid] = useState("");
  const navigate = useNavigate();

  

  const [brands, setBrands] = useState([]);

  const openAddCategoryModal = (event) => {
    reset();
    setBrandId("");

    setisAddCategoryModal(true);
  };

  
useEffect(()=>{
  setOrder('desc');
  setOrderBy('brand_id')
},[])

const openEditCategoryModal = (row) => {
  console.log("Selected Row Data:", row);

  setSelectedRow(row); // Save the entire row data
  setSelectedCategory(row.category_id || ""); // Set the category_id for dropdown value
  setCategoryName(row.category_name || ""); // Set the category_name for placeholder
  setNewFieldValue(row.brand_name || ""); // Prepopulate brand field
  setSelectedbrandid(row.brand_id || ""); // Set brand ID for tracking

  setisEditCategoryModal(true); // Open the edit modal
};

 
  const handleDropdownChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const reset = () => {
    setCategoryId("");
    setSelectedCategory("");
    setBrandName("");
    setCategoryLabel("Select Category");
    setNewFieldValue('');
    setNewFieldLabel('Enter Brand');
    setCategoryNameError(false);
    setNewFieldError(false);
    console.log("Reset called. New Field Value:", newFieldValue);
  };

 


  const resetSelectedRows = () => {
    setSelectedRows([]);
    console.log("Checkboxes refreshed");
  };



  const validateFields = () => {
    let isValid = true;

    if (!selectedCategory || selectedCategory.toString().trim() === "") {
      setCategoryNameError(true);
      setCategoryLabel("* Category Required");
      isValid = false;
    } else {
      setCategoryNameError(false);
      setCategoryLabel(""); // Reset label if no error
    }

    if (!newFieldValue || newFieldValue.trim() === "") {
      setNewFieldError(true);
      setBrandLabel("* Brand Required");
      isValid = false;
    } else {
      setNewFieldError(false);
      setBrandLabel(""); // Reset label if no error
    }

    return isValid;
  };







  const updatevalidateFields = () => {
    let isValid = true;

   
    if (!newFieldValue || newFieldValue.trim() === "") {
      setNewFieldError(true);
      setBrandLabel("* Brand Required");
      isValid = false;
    } else {
      setNewFieldError(false);
      setBrandLabel(""); // Reset label if no error
    }

    return isValid;
  };





  useEffect(() => {
    getbrand();
  }, []);


  const getCategory = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/brand/getcategoryall`,
        {
          method: "GET",
          headers: { "Content-type": "application/json" },
          credentials: "include",
        }
      );
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin");
        return;
      }
      const data = await response.json();
      setcategory(data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  
  useEffect(() => {
    if (categoryId) {
      getbrand();
    }

  }, [categoryId]);

  const getbrand = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/brand/getbrand`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        }
      );
  
      // Handle 401 Unauthorized (Session Expired)
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin");
        return;
      }
  
      if (!response.ok) {
        throw new Error("Failed to fetch brands.");
      }
  
      const data = await response.json();
      setBrands(data);
  
      console.log("API response of getbrand:", data);
      
      // Ensure brands exist before setting brand_id to avoid errors
      if (data.length > 0) {
        setBrandId(data[0].brand_id);
      }
    } catch (error) {
      console.error("Error fetching brands:", error);
      setSnackbarMessage(error.message || "Failed to load brands.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };
  

  const handleResponse = (responseObject) => {
    if (responseObject.status === 200) {
      setisAddCategoryModal(false);
      reset();
      getbrand();
    }
    if (responseObject.status === 400) {
      setSnackbarMessage(responseObject.error);

    }
  }

  const cancelDelete = () => {
    resetSelectedRows();
    setIsConfirmationOpen(false);
  };


  const handleDelete = () => {
    if (selectedRows.length === 0) {
      setDeleteMsg("Please select Brand before deleting.");
      setIsConfirmationOpen(true);

      return;
    }
    setDeleteMsg("Are you sure you want to delete the selected Brand?");
    setIsConfirmationOpen(true);
  };

  const confirmDelete = async () => {
    if (selectedRows.length === 0) {
      setSnackbarMessage("No brand selected for deletion.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      setIsConfirmationOpen(false);
      return;
    }
  
    try {
      console.log("Selected rows to delete:", selectedRows);
      setSelectedRows([]); 
      setIsConfirmationOpen(false); 
      // Make an API request to delete selected brands
      const response = await axios.post(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/brand/deletebrand`,
        { brandId: selectedRows }, // Payload
        { withCredentials: true } // Include credentials for authentication
      );
  
      // Axios does not return response.status directly like fetch, so check response.data
      if (response.data?.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin");
        return;
      }
  
      // Handle success response
      setSelectedRows([]);
      setIsConfirmationOpen(false); // Close confirmation modal
  
      // Refresh the list of brands
      await getbrand();
      getbrand();
      setSnackbarMessage(response.data.message || "Brand deleted successfully.");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error deleting brand:", error);
  
      // Handle 401 Unauthorized in the error response
      if (error.response?.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin");
        return;
      }
  
      // Handle other errors
      const errorMessage =
        error.response?.data?.message || "An error occurred while deleting the brand.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      setIsConfirmationOpen(false);
    }
  };
  
  


  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = paginatedRows.map((row) => row.brand_id);
      setSelectedRows(newSelecteds);
      console.log("Selected all rows:", newSelecteds);
    } else {
      setSelectedRows([]);
      console.log("Deselected all rows");
    }
  };



  const handleCheckboxClick = (event, brand_id) => {
    const newSelectedRows = event.target.checked
      ? [...selectedRows, brand_id]  // Add to selectedRows
      : selectedRows.filter((id) => id !== brand_id);  // Remove from selectedRows
    setSelectedRows(newSelectedRows);
  };

  const handleModelClose = () => {
    resetSelectedRows();
    setIsUserFormOpen(false);
    setSelectedUser(null);
  };

  const handleClose = () => {
    setisAddCategoryModal(false);
    setisEditCategoryModal(false);

    setBrandName("");
    setNewFieldLabel("Enter Brand");
    setCategoryLabel("Select Category");
    setCategoryId(0);
    setCategoryNameError(false);
    setCategoryNameError(false);
    resetSelectedRows();
    reset();
  };


  const handleChangeCategory = (event) => {
    const selectedCategoryId = event.target.value; // Get selected category_id
    setSelectedCategory(selectedCategoryId); // Update selected category_id state
  
    // Find the selected category object
    const selectedCategoryObj = category.find(
      (pm) => pm.category_id === parseInt(selectedCategoryId, 10)
    );
  
    if (selectedCategoryObj) {
      setCategoryName(selectedCategoryObj.category_name); // Update category_name
      setCategoryError(false); // Clear errors
    } else {
      setCategoryName(""); // Clear category_name if invalid
      setCategoryError("Invalid category selected."); // Set error message
    }
  };
  

  const savebrand = async () => {
    console.log("Selected Category (ID):", selectedCategory);
    console.log("New Field Value:", newFieldValue);
  
    if (validateFields()) {
      try {
        const payload = {
          brand_name: newFieldValue.trim(), // Trim spaces from brand_name
          category_id: selectedCategory,   // Send category_id (numeric)
        };
  
        console.log("Payload being sent:", payload);
  
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/brand/savebrand`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify(payload),
          }
        );
  
        // Handle 401 Unauthorized (Session Expired)
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin");
          return;
        }
  
        if (response.ok) {
          const data = await response.json();
          setSnackbarMessage(data.message || "Brand saved successfully!");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          setOrder("desc");
          resetSelectedRows();
          handleClose();
          getbrand(); // Refresh the list
        } else {
          const errorData = await response.json();
          setSnackbarMessage(response.status === 409 ? "Brand already exists." : errorData.message || "Failed to save brand!");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        console.error("Error saving brand:", error);
        setSnackbarMessage("An error occurred while saving the brand.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    }
  };
  
  const editbrand = async () => {
    if (updatevalidateFields()) {
      try {
        const payload = {
          brand_id: selectedbrandid,        // Send the selected brand_id
          brand_name: newFieldValue.trim(), // Trim spaces from brand_name
        };
  
        console.log("Payload being sent for edit:", payload);
  
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/brand/editbrand`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify(payload),
          }
        );
  
        // Handle 401 Unauthorized (Session Expired)
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin");
          return;
        }
  
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Error response:", errorData);
          throw new Error(errorData.message || "Failed to update brand");
        }
  
        const data = await response.json();
        console.log("Edit Response:", data);
  
        setSnackbarMessage(data.message || "Brand updated successfully");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        reset(); // Reset fields after success
        handleClose();
        resetSelectedRows();
        getbrand(); // Re-fetch the brands
      } catch (error) {
        console.error("Error during update:", error);
        setSnackbarMessage(error.message || "Failed to update brand");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    }
  };
  

  useEffect(() => {
    getCategory();
    getbrand();
  }, []);


  const handleChangePage = (event, newPage) => {
    resetSelectedRows();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    resetSelectedRows();
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    resetSelectedRows();
    setSearchQuery(event.target.value);
    setPage(0);
  };


  const handleSortRequest = (property) => {
    resetSelectedRows();
    const isAsc = orderBy === property && order === "asc";
    const newOrder = isAsc ? "desc" : "asc";
    console.log("Sorting by:", property, "Order:", newOrder);
    setOrder(newOrder);
    setOrderBy(property);
  };


  const filteredRows = brands.filter((row) => {
    const searchTerms = searchQuery.toLowerCase().split(" ").filter(Boolean);

    return searchTerms.every((term) =>
      (row.brand_id && String(row.brand_id).toLowerCase().includes(term)) ||
      (row.brand_name && String(row.brand_name).toLowerCase().includes(term)) ||
      (row.category_name && String(row.category_name).toLowerCase().includes(term)) ||
      (row.total_quantity && String(row.total_quantity).toLowerCase().includes(term))
    );
  });

  const sortedRows = [...filteredRows].sort((a, b) => {
    if (orderBy === "brand_id" || orderBy === "total_quantity") {
      // Sort numerical columns
      return (
        (order === "asc" ? 1 : -1) *
        (Number(a[orderBy] || 0) - Number(b[orderBy] || 0))
      );
    } else if (orderBy === "brand_name" || orderBy === "category_name") {
      // Sort string columns
      return (
        (order === "asc" ? 1 : -1) *
        (a[orderBy]?.toString().localeCompare(b[orderBy]?.toString()) || 0)
      );
    } else {
      return 0; // Default case, no sorting
    }
  });



  const paginatedRows = sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleSnackbar = (msg, severity) => {
    setSnackbarSeverity(severity);
    setSnackbarMessage(msg);
    setSnackbarOpen(true);
  };

  return (
    <>
      <Layout />
      <h1 className="title" >Brand</h1>

      <Dialog //add dilouge
        onClose={handleClose} open={isAddCategoryModal} sx={{ '& .MuiDialog-paper': { width: '350px', height: 'auto', maxHeight: '400px', overflow: 'hidden', }, }}>
        <DialogTitle alignSelf={'center'} sx={{ padding: '0.5px 12px' }}>
          <span style={{ display: 'flex', alignItems: 'center', color: '#0A64A2', fontSize: '1em', marginRight: '7em' }}>
          <img src={BrandIcon} alt="category Image"  
              style={{
                marginRight: '0.2px', 
                width: '40px', 
                height: '45px', 
                position: 'relative', // Allow top property to take effect
                 top: '1.4em',
                 right:'3.8%'
              }}
            />            
            <span style={{ color: '#0A64A2', fontSize: '1.2em',  position: 'relative', top: '1.5em', left: '0.0em', }}>
              Add Brand
            </span>
          </span>
          {/* <span style={{ display: 'inline-block', borderBottom: '2.4px solid #0A64A2', lineHeight: '1.5', width:'40em',}}></span> */}
          <span style={{ display: 'block', position: 'relative', borderBottom: '2.4px solid #0A64A2',lineHeight: '1.5', width: '300px', top: '1.6em', right: '0.0em', }} />
        </DialogTitle>
        <IconButton aria-label="close" onClick={handleClose} sx={{ position: 'absolute', right: 4, top: 1, color: (theme) => theme.palette.grey[500], }}>
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ padding: '16px' }}>
          <Stack spacing={2} padding={1}>

            <TextField
              id="outlined-basic"
              error={!!categoryNameError}
              value={selectedCategory || ""}
              onChange={handleChangeCategory}
              size="small"
              label={categoryLabel || "Select Category"}
              variant="outlined"
              select
              sx={{ top: "1.3em" }}
            >
              <MenuItem value="">
                <em>Select an option</em>
              </MenuItem>
              {category.map((pm) => (
        <MenuItem key={pm.category_id} value={pm.category_id}>
          {pm.category_name}
        </MenuItem>
              ))}
            </TextField>




            <TextField
              id="outlined-basic"
              error={newFieldError}
              value={newFieldValue || ""} // Use newFieldValue to bind the brand name
              onChange={(e) => setNewFieldValue(e.target.value)} // Update brand name on change
              size="small"
              label={brandLabel}
              variant="outlined"
              sx={{ top: "1.3em" }}
            />


            <Button sx={{ alignSelf: 'center', width: '80px', height: '40px', padding: '12px 34px', marginLeft: 'auto', marginRight: 'auto', backgroundColor: '#0A64A2', color: 'white', left: '7.9em', top: '1em', }} variant="contained"
              onClick={savebrand}> Save
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>



      <Dialog //edit dilaog
        onClose={handleClose} open={isEditCategoryModal} sx={{ '& .MuiDialog-paper': { width: '350px', height: 'auto', maxHeight: '400px', overflow: 'hidden', }, }}>
        <DialogTitle alignSelf={'center'} sx={{ padding: '0.5px 14px' }}>
          <span style={{ display: 'flex', alignItems: 'center', color: '#0A64A2', fontSize: '1em', marginRight: '7em' }}>
          <img src={BrandIcon} alt="category Image" 
              style={{
                marginRight: '0.2px', 
                width: '39px', 
                height: '44px', 
                position: 'relative', // Allow top property to take effect
                 top: '1.4em',
                 right:'5px',
              }}
            />   
            <span style={{ color: '#0A64A2', fontSize: '1.2em', position: 'relative', top: '1.5em', left: '0.0em', }}>
              Edit Brand
            </span>
          </span>
          <span style={{ display: 'block', position: 'relative', borderBottom: '2.4px solid #0A64A2', width: '300px', top: '1.5em', right: '0.0em', }} />
        </DialogTitle>
        <IconButton aria-label="close" onClick={handleClose} sx={{ position: 'absolute', right: 4, top: 1, color: (theme) => theme.palette.grey[500], }}>
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ padding: '16px' }}>
          <Stack spacing={2} padding={1}>

       



           <TextField
              id="outlined-basic"
              // error={!!categoryNameError}
              value={selectedCategory || ""}
              // onChange={handleChangeCategory}
              size="small" 

              label={categoryLabel2 || ""}
              variant="outlined"
              select
              disabled
              sx={{ top: "1.3em" }}

              InputProps={{
                displayEmpty: true, // Allow a custom placeholder
              }}
              SelectProps={{
                displayEmpty: true, // Ensure placeholder works for dropdown
              }}
            >
              <MenuItem value="">
              <span>{categoryName || ""}</span>
              </MenuItem>
              {category.map((pm) => (
                <MenuItem key={pm.category_id} value={pm.category_id}>
                  {pm.category_name}
                </MenuItem>
              ))}
            </TextField>





            <TextField
              id="outlined-basic"
              error={newFieldError}
              value={newFieldValue || ""} // Use newFieldValue to bind the brand name
              onChange={(e) => setNewFieldValue(e.target.value)} // Update brand name on change
              size="small"
              label={brandLabel}
              variant="outlined"
              sx={{ top: "1.3em" }}
            />


            <Button sx={{ alignSelf: 'center', width: '80px', height: '40px', padding: '12px 34px', marginLeft: 'auto', marginRight: 'auto', backgroundColor: '#0A64A2', color: 'white', left: '7.9em', top: '1em', }} variant="contained"
              onClick={editbrand}> update
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>

      <Container>
        <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center", }}>
          <div style={{ display: "flex" }}>
            <TextField
              sx={{ minWidth: 300, mt: 0, mb: 0, pt: 0, pb: 0 }}
              label="Search..."
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={handleSearchChange}
              size="small"
              style={{ marginBottom: "0.3rem", border: "none" }}
              InputProps={{
                startAdornment: (
                  <SearchIcon sx={{ color: 'gray', marginRight: '8px' }} />
                ),
              }}
            />
          </div>
          <div style={{ display: "flex" }}>
            <Button sx={{ width: '50%', right: '1%' }} variant="contained" className="blue-btn" onClick={handleDelete}>
              Delete
            </Button>
            <Button
              className="blue-btn"
              onClick={openAddCategoryModal}
            >
              Add Brand
            </Button>
          </div>
          <Modal open={isConfirmationOpen} onClose={cancelDelete}>
            <Box sx={ModalStyle}>
              <Typography sx={{ fontSize: "1.1em", color: "#0A64A2" }}>
                {deleteMsg}
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
                {selectedRows.length === 0 ? (
                  ""
                ) : (
                  <Button
                    variant="contained"
                    onClick={confirmDelete}
                    className="no-btn"
                  >
                    Yes
                  </Button>
                )}
                <Button
                  variant="contained"
                  onClick={cancelDelete}
                  className="no-btn"
                >
                  {deleteMsg === "Please select brand before deleting." ? "Ok" : "NO"}
                </Button>
              </Box>
            </Box>
          </Modal>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}

        <TableContainer component={Paper} >
          <div style={{ maxHeight: "", overflow: "hidden" }}>
            <Table>
              <TableHead
                style={{
                  height: "60px",
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#fff",
                }}
              >
                <TableRow
                  style={{
                    cursor: "pointer",
                    height: "60px",
                    position: "sticky",
                  }}
                >
                  <StyledTableCell padding="checkbox" sx={{ width: "5%", textAlign: 'center' }}>
                    <Checkbox
                      color="primary"
                      indeterminate={
                        selectedRows.length > 0 &&
                        selectedRows.length < paginatedRows.length
                      }
                      checked={
                        paginatedRows.length > 0 &&
                        selectedRows.length === paginatedRows.length
                      }
                      onChange={handleSelectAllClick}
                      inputProps={{
                        "aria-label": "select all attribute",
                      }}
                    />
                  </StyledTableCell>

                  {[
                    { id: "brand_id", label: "Brand Id" },
                    { id: "brand_name", label: "Brand Name" },
                    { id: "category_name", label: "Category" },
                    { id: "total_quantity", label: "No.of Product" },

                  ].map((column) => (
                    <StyledTableCell
                      key={column.id}
                      align="center"
                      onClick={() => handleSortRequest(column.id)}
                      sx={{
                        // position: "sticky",
                        width: "20%", // Fixed width for consistency
                        padding: "8px", // Adequate padding for stability
                        position: "relative",
                        height: "60px", // Ensure header cells match the row height
                        "& .MuiTableSortLabel-root": {
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "100%",
                          height: "100%", // Ensure sort label spans the full height
                          boxSizing: "border-box", // Ensures padding and border are included in the height
                        },
                        "& .MuiTableSortLabel-icon": {
                          marginLeft: "8px", // Space between text and icon
                          position: "relative",
                          top: "2px", // Adjust vertical alignment if needed

                        },
                        "&:hover .MuiTableSortLabel-root": {
                          color: "black", // Hover color
                          position: "sticky",
                        },
                        "& .Mui-active": {
                          color: "white", // Active color
                          position: "sticky",
                        },
                      }}
                    >

                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}

                      >
                        {column.label}
                      </TableSortLabel>
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {paginatedRows.map((row) => (
                  <StyledTableRow key={row.brand_id} hover>
                    {/* Checkbox Column (First) */}
                    <StyledTableCell padding="checkbox" align="center" style={{ textAlign: 'center' }}>
                      <Checkbox
                        color="primary"
                        checked={selectedRows.includes(row.brand_id)}  // Use attribute_id consistently
                        onChange={(event) => handleCheckboxClick(event, row.brand_id)}
                        inputProps={{
                          "aria-label": `select attribute ${row.brand_id}`,
                        }}
                      />
                    </StyledTableCell>

                    {/* Attribute Id Column */}
                    <StyledTableCell onClick={() => openEditCategoryModal(row)} align="center" component="th" scope="row">
                      {row.brand_id}
                    </StyledTableCell>

                    {/* Attribute Name Column */}
                    <StyledTableCell onClick={() => openEditCategoryModal(row)} align="center" style={{ cursor: "pointer" }}>
                      {row.brand_name}
                    </StyledTableCell>

                    <StyledTableCell onClick={() => openEditCategoryModal(row)} align="center" style={{ cursor: "pointer" }}>
                      {row.category_name}
                    </StyledTableCell>

                    {/* Role Name Column */}
                    <StyledTableCell onClick={() => openEditCategoryModal(row)} align="center" style={{ cursor: "pointer" }}>
                      {row.total_quantity}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>

            </Table>
          </div>

          <TablePagination
            style={{ background: "#0A64A2", color: "#fff" }}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}

          />
        </TableContainer>
      </Container>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          // onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ alignItems: "center", width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}